<agr-page-detail
  [pageTitle]="title"
  [hasPrimaryAction]="true"
  primaryActionIcon="print"
  primaryActionText="Print"
  (primaryAction)="print()"
  (backAction)="back()"
>
  <agr-print-page
    data-test="flock-report__page"
    [customizedLogoSrc]="customizedLogoSrc"
    [showAgrifirmLogo]="showAgrifirmLogo"
  >
    <div class="screen-only wrapper--spacing-horizontal wrapper--spacing-vertical">
      <div class="spacing--margin-bottom">
        <div class="spacing--margin-top flex--row flex--nowrap">
          <div class="flex--column year-width">
            <mat-label>
              {{ 'report.animalcount.year' | translate }}
            </mat-label>
            <mat-select
              [hideSingleSelectionIndicator]="true"
              class="text--small"
              placeholder="{{ 'report.animalcount.year-placeholder' | translate }}"
              data-test="report_animalcount_years"
              [(ngModel)]="selectedYear"
              (selectionChange)="changeYear()"
            >
              <mat-option *ngFor="let year of years" [value]="year">{{ year }}</mat-option>
            </mat-select>
          </div>
        </div>
      </div>
      <mat-divider></mat-divider>
    </div>

    <div class="wrapper--spacing-horizontal wrapper--spacing-vertical">
      <ul class="info-header">
        <li>
          <label class="text-bold">{{ 'report.animalcount.farmcompany' | translate }}:</label>
          <label class="wide-label">
            {{ (customer$ | async)?.name }}, {{ (customer$ | async)?.street }}
            {{ (customer$ | async)?.houseNumber }} {{ (customer$ | async)?.houseNumberAddition }},
            {{ (customer$ | async)?.city }}
          </label>
        </li>
        <li>
          <label class="text-bold">{{ 'report.animalcount.customernr' | translate }}:</label>
          <label>{{ (customer$ | async)?.externalId }}</label>
        </li>
        <li>
          <label class="text-bold">{{ 'report.animalcount.location' | translate }}:</label>
          <label class="wide-label">
            {{ (location$ | async)?.name }}, {{ (location$ | async)?.street }}
            {{ (location$ | async)?.houseNumber }} {{ (location$ | async)?.houseNumberAddition }},
            {{ (location$ | async)?.city }}
          </label>
        </li>
        <li>
          <label class="text-bold">{{ 'report.animalcount.flock' | translate }}:</label>
          <label>{{ (selectedFlock$ | async)?.name }}</label>
        </li>
        <li>
          <label class="text-bold">{{ 'report.animalcount.barn' | translate }}:</label>
          <label>{{ (selectedFlock$ | async)?.arrival?.barn?.name }}</label>
        </li>
        <li>
          <label class="text-bold">{{ 'report.animalcount.arrivaldate' | translate }}:</label>
          <label>{{ (selectedFlock$ | async)?.arrival?.arrivalDate | agrDate: 'shortDate' }}</label>
          <label class="text-bold">{{ 'report.animalcount.arrivalamount' | translate }}:</label>
          <label>{{ (selectedFlock$ | async)?.arrival?.amountOfHens }}</label>
        </li>
        <li>
          <label class="text-bold">{{ 'report.animalcount.departuredate' | translate }}:</label>
          <label>{{
            (selectedFlock$ | async)?.departure?.departureDate | agrDate: 'shortDate'
          }}</label>
          <label class="text-bold">{{ 'report.animalcount.departureamount' | translate }}:</label>
          <label>{{ (selectedFlock$ | async)?.departure?.amount }}</label>
        </li>
      </ul>
    </div>
    <div class="wrapper--spacing-horizontal" *ngIf="selectedAnimalCountCard">
      <table>
        <thead>
          <tr>
            <th>{{ 'report.animalcount.mutationdate' | translate }}</th>
            <th>{{ 'report.animalcount.reason' | translate }}</th>
            <th>{{ 'report.animalcount.mutation' | translate }}</th>
            <th>{{ 'report.animalcount.amountbeforemutation' | translate }}</th>
            <th>{{ 'report.animalcount.amountaftermutation' | translate }}</th>
            <th>{{ 'report.animalcount.numberofdays' | translate }}</th>
            <th>{{ 'report.animalcount.animaldays' | translate }}</th>
            <th>{{ 'report.animalcount.average' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let mutation of selectedAnimalCountCard.mutations">
            <td>{{ mutation.date | agrDate: 'shortDate' }}</td>
            <td>{{ 'report.animalcount.reasons.' + mutation.reason | translate }}</td>
            <td class="align-right">{{ mutation.mutation | agrNumber: '1.0-0' }}</td>
            <td class="align-right">{{ mutation.amountBeforeMutation | agrNumber: '1.0-0' }}</td>
            <td class="align-right">{{ mutation.amountAfterMutation | agrNumber: '1.0-0' }}</td>
            <td class="align-right">{{ mutation.numberOfDays | agrNumber: '1.0-0' }}</td>
            <td class="align-right">{{ mutation.animalDays | agrNumber: '1.0-0' }}</td>
            <td></td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="tableSeparator">
            <td>{{ 'report.animalcount.total' | translate }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="align-right">{{ selectedAnimalCountCard.totalNumberOfDays | agrNumber }}</td>
            <td class="align-right">
              {{ selectedAnimalCountCard.totalAnimalDays | agrNumber: '1.0-0' }}
            </td>
            <td class="align-right">
              {{ selectedAnimalCountCard.totalAnimalCount | agrNumber: '1.0-0' }}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </agr-print-page>
</agr-page-detail>
